import { getWeek } from 'date-fns';
import Page from './page';
import CartQuantitySelector from '../components/cart/cart-quantity-selector';
import InitialOrderCartForm from '../components/initial-order/initial-order-cart-form';
import AsyncStock from '../components/product/async-stock';

export default class InitialOrderCartPage extends Page {
  static readonly MAX_DELIVERY_WEEK_EVENT = 'maxDeliveryAvailabilityWeek';
  static readonly SELECTED_DELIVERY_WEEK_EVENT = 'selectedDeliveryAvailabilityWeek';

  private selectedDeliveryAvailabilityWeek = getWeek(new Date($('.js-initial-order-cart-form .js-deliveryWeek').val() as string));
  private maxDeliveryAvailabilityWeek = 0;
  private readonly cartNotDeliverableBannerEl = document.querySelector('.js-cart-not-deliverable-banner');

  private readonly initialOrderCartForm: InitialOrderCartForm;

  constructor() {
    super(true);
    this.initialOrderCartForm = new InitialOrderCartForm($('.js-initial-order-cart-form'));
  }

  init(): void {
    super.init();
    CartQuantitySelector.initAll();

    document.body.addEventListener(InitialOrderCartPage.MAX_DELIVERY_WEEK_EVENT, (event) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (this.maxDeliveryAvailabilityWeek < (event as CustomEvent).detail.week) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
        this.maxDeliveryAvailabilityWeek = (event as CustomEvent).detail.week;
      }
    });

    document.body.addEventListener(InitialOrderCartPage.SELECTED_DELIVERY_WEEK_EVENT, (event) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
      this.selectedDeliveryAvailabilityWeek = (event as CustomEvent).detail.week;
      this.toggleCartNotDeliverableBanner();
    });

    document.body.addEventListener(AsyncStock.DELIVERY_LOADED_EVENT, () => {
      this.toggleCartNotDeliverableBanner();
    });
  }

  toggleCartNotDeliverableBanner(): void {
    if (this.selectedDeliveryAvailabilityWeek < this.maxDeliveryAvailabilityWeek) {
      this.cartNotDeliverableBannerEl?.classList.remove('is-hidden');
    } else {
      this.cartNotDeliverableBannerEl?.classList.add('is-hidden');
    }
  }
}
